"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6V5h2.0001V3H19V2h-3.0001c-1.5854.0001-2.9247 1.0543-3.355 2.5h-.6448C9.7613 4.5 7.8661 5.9715 7.229 8h2.1724c.5187-.8967 1.4883-1.5 2.5987-1.5h.6448c.4303 1.4459 1.7696 2.5002 3.3552 2.5001H19V8h2.0001V6H19zm-2-2v3.0001h-1.0086c-.8245-.0046-1.4914-.6744-1.4914-1.5 0-.8284.6715-1.5 1.5-1.5h1zM6.882 9.5h8.295l1.8 4.5001H17c1.1046 0 2 .8954 2 2v4h-1.5v2h-3v-2h-7v2h-3v-2H3v-4c0-.9723.6938-1.7825 1.6133-1.9627L6.882 9.5001zm6.941 2.0001 1 2.5H6.868l1.25-2.5h5.705zm-7.823 7c.6904 0 1.25-.5597 1.25-1.25 0-.6904-.5596-1.25-1.25-1.25s-1.25.5596-1.25 1.25c0 .6903.5596 1.25 1.25 1.25zm11.25-1.25c0 .6903-.5596 1.25-1.25 1.25s-1.25-.5597-1.25-1.25c0-.6904.5596-1.25 1.25-1.25s1.25.5596 1.25 1.25z"
  })];
};

exports.default = _default;